import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import moment from 'moment-timezone';
import { Icon } from 'front-onceforall-core';
import Tooltip from '@material-ui/core/Tooltip';
import { USER_ORGANISATION_STATUS, USER_UNLINKABILITY_STATUS } from '../../utils/constant';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const statusStyles = {
  [USER_ORGANISATION_STATUS.PENDING]: {
    lineClass: null,
    lineStyle: {
      backgroundColor: 'rgb(38, 56, 69, 0.04)'
    },
    chipClass: 'warning',
    chipLabel: /*#__PURE__*/_jsx(Translate, {
      value: 'users.status.PENDING'
    })
  },
  [USER_ORGANISATION_STATUS.LINKED]: {
    lineClass: null,
    lineStyle: null,
    chipClass: null,
    chipLabel: /*#__PURE__*/_jsx(Translate, {
      value: 'users.status.LINKED'
    })
  },
  DEACTIVATED: {
    lineClass: 'italic information',
    lineStyle: null,
    chipClass: 'information-light',
    chipLabel: /*#__PURE__*/_jsx(Translate, {
      value: 'users.status.DEACTIVATED'
    })
  }
};
export const UsersView = props => {
  const renderChip = userOrganisation => {
    const {
      chipClass,
      chipLabel
    } = statusStyles[userOrganisation.user.enabled ? userOrganisation.status : 'DEACTIVATED'];
    return /*#__PURE__*/_jsx("span", {
      className: `chip ${chipClass ? chipClass : ''}`,
      style: {
        display: 'flex',
        justifyContent: 'center'
      },
      children: chipLabel
    });
  };
  const renderActions = (index, userOrganisation) => {
    const actionButtons = [];
    const userId = userOrganisation.user.id;
    let message = 'users.actions.unlinkUserImpossibility';
    const isUserUnlinkable = userOrganisation.unlinkStatus === USER_UNLINKABILITY_STATUS.OK;
    if (isUserUnlinkable) {
      message = 'users.actions.unlinkUser';
    } else if (userOrganisation.unlinkStatus === USER_UNLINKABILITY_STATUS.LAST_MANDATORY_ROLES) {
      message = 'users.actions.unlinkUserLastMandatoryRoles';
    }

    // "Unlink user" button
    actionButtons.push(/*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(Translate, {
        value: message
      }),
      placement: "top",
      children: /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx("button", {
          type: "button",
          className: "button-square clickable",
          "data-id": 'unlink-user-' + index,
          onClick: event => props.onUnlinkUser(event, userId),
          style: isUserUnlinkable ? {} : {
            pointerEvents: 'none'
          },
          children: /*#__PURE__*/_jsx(Icon, {
            icon: "trash",
            color: isUserUnlinkable ? 'tertiary' : 'information-light'
          })
        })
      })
    }, index + '-' + actionButtons.length));
    if (userOrganisation.status === USER_ORGANISATION_STATUS.PENDING) {
      // "Accept pending user request" button
      actionButtons.push(/*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(Translate, {
          value: "users.actions.acceptPendingUserRequest"
        }),
        placement: "top",
        children: /*#__PURE__*/_jsx("button", {
          type: "button",
          className: "button-square success",
          "data-id": 'accept-pending-user-' + index,
          onClick: event => props.onAcceptPendingUser(event, userId),
          children: /*#__PURE__*/_jsx(Icon, {
            icon: "check"
          })
        })
      }, index + '-' + actionButtons.length));

      // "Decline pending user request" button
      actionButtons.push(/*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(Translate, {
          value: "users.actions.declinePendingUserRequest"
        }),
        placement: "top",
        children: /*#__PURE__*/_jsx("button", {
          type: "button",
          className: "button-square error",
          "data-id": 'decline-pending-user-' + index,
          onClick: event => props.onDeclinePendingUser(event, userId),
          children: /*#__PURE__*/_jsx(Icon, {
            icon: "cross"
          })
        })
      }, index + '-' + actionButtons.length));
    }
    if (actionButtons.length) {
      return /*#__PURE__*/_jsx("div", {
        className: "actions inline-container",
        style: {
          justifyContent: 'space-evenly'
        },
        children: actionButtons
      });
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex-container space-between",
      children: [/*#__PURE__*/_jsx("div", {
        className: "row mt-4 mb-5",
        children: /*#__PURE__*/_jsxs("h1", {
          "data-id": "organisation-users",
          className: "md-6 m-0",
          children: [/*#__PURE__*/_jsx(Translate, {
            value: "users.users"
          }), /*#__PURE__*/_jsx("span", {
            className: "separator information",
            children: props.users.length
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "md-6 inline-container flex-end",
        children: /*#__PURE__*/_jsxs("button", {
          type: "button",
          "data-id": "invite-user-button",
          className: "large cta inline-container",
          onClick: () => props.onClickInviteButton(true),
          children: [/*#__PURE__*/_jsx(Icon, {
            icon: "plus"
          }), /*#__PURE__*/_jsx(Translate, {
            value: "user.invite.button"
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "card col-12",
      children: props.error ? /*#__PURE__*/_jsx("span", {
        "data-id": "error-message",
        children: /*#__PURE__*/_jsx(Translate, {
          value: "error.generic"
        })
      }) : props.loading ? /*#__PURE__*/_jsx("span", {
        className: "loading-overlay"
      }) : props.users.length > 0 ? /*#__PURE__*/_jsxs("table", {
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx(Translate, {
                value: "user.firstName"
              })
            }), /*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx(Translate, {
                value: "user.lastName"
              })
            }), /*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx(Translate, {
                value: "user.email"
              })
            }), /*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx(Translate, {
                value: "user.phoneNumber"
              })
            }), /*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx(Translate, {
                value: "users.organisation.linkingDate"
              })
            }), /*#__PURE__*/_jsx("td", {}), /*#__PURE__*/_jsx("td", {})]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: props.users.map((userOrganisation, index) => {
            const {
              lineClass,
              lineStyle
            } = statusStyles[userOrganisation.user.enabled ? userOrganisation.status : 'DEACTIVATED'];
            return /*#__PURE__*/_jsxs("tr", {
              className: lineClass,
              style: lineStyle,
              children: [/*#__PURE__*/_jsx("td", {
                children: userOrganisation.user.firstName
              }), /*#__PURE__*/_jsx("td", {
                children: userOrganisation.user.lastName
              }), /*#__PURE__*/_jsx("td", {
                children: userOrganisation.user.email
              }), /*#__PURE__*/_jsx("td", {
                children: userOrganisation.user.phoneNumber
              }), /*#__PURE__*/_jsx("td", {
                children: moment(userOrganisation.linkingDate).format('DD/MM/YYYY')
              }), /*#__PURE__*/_jsx("td", {
                className: "no-wrap",
                style: {
                  width: '1%'
                },
                children: renderChip(userOrganisation)
              }), /*#__PURE__*/_jsx("td", {
                children: renderActions(index, userOrganisation)
              })]
            }, index);
          })
        })]
      }) : /*#__PURE__*/_jsx("div", {
        className: "table-without-result",
        children: /*#__PURE__*/_jsx(Translate, {
          value: "users.organisation.noUsers"
        })
      })
    })]
  });
};
UsersView.propTypes = {
  users: PropTypes.array,
  onAcceptPendingUser: PropTypes.func.isRequired,
  onDeclinePendingUser: PropTypes.func.isRequired,
  onUnlinkUser: PropTypes.func.isRequired,
  onClickInviteButton: PropTypes.func.isRequired,
  error: PropTypes.bool,
  loading: PropTypes.bool
};
UsersView.defaultProps = {
  users: [],
  loading: true,
  error: false
};
export default UsersView;